<!-- #737 Eltern-Zeile: links Typ/Empfaenger/Zeitpunkt, rechts die drei Kanalplaetze. Die Breite
     w-28 muss mit der Kopfzeile in notification-admin-list.component.html uebereinstimmen, sonst
     laufen die Spalten auseinander. -->
<div
  class="flex flex-row items-center px-5 py-2 text-[14px] leading-[1.325rem] cursor-pointer hover:bg-gray-50"
  (click)="onRowClick($event)">

  <div class="grow flex flex-col min-w-0">
    <!-- typeKey bleibt bewusst technisch: die Liste liefert kein Label, und fuer Support ist der
         Schluessel die brauchbarere Information. -->
    <span class="font-medium break-all">{{ entry().typeKey }}</span>
    <span class="text-[#848488] break-all">
      {{ recipientDisplay() }} · {{ entry().createdAt | date:'dd.MM.yyyy HH:mm' }} ·
      {{ readStateKey() | translate }}
    </span>
  </div>

  @for (cell of cells(); track cell.channel) {
    <div class="w-28 shrink-0 flex flex-row justify-center">
      @if (cell.present) {
        <!-- Ein p-tag je Kanal, wie in den Zustellzeilen des Detail-Screens. Die Gewichtung steckt
             in der Farbe: danger = Befund, warning = Hinweis, success = zugestellt, info = neutral
             (laufend, oder vom Nutzer selbst abgewaehlt). -->
        <p-tag [value]="cell.labelKey | translate" [severity]="cell.severity"></p-tag>
      }
      <!-- Kein @else: ein Kanal, den der Typ nicht kennt, bekommt keine Kachel. Der Platz bleibt
           trotzdem stehen, sonst ruecken die folgenden Spalten nach links. -->
    </div>
  }
</div>
